
const createMutationRequest = (apiRequest) => {
  return (...props) => {
    return apiRequest(null, ...props);
  };
};

export default createMutationRequest;
